import { render, staticRenderFns } from "./OrgLeadsWantedByMonth.vue?vue&type=template&id=0d460fec&scoped=true&"
import script from "./OrgLeadsWantedByMonth.vue?vue&type=script&lang=js&"
export * from "./OrgLeadsWantedByMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d460fec",
  null
  
)

export default component.exports